<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Contents">
<h2 class="h2f"><span class="pgref" epub:type="pagebreak" id="page_vi" title="vi"><span class="pgref" epub:type="pagebreak" id="page_vii" title="vii">Contents</span></span></h2>
<p class="toc"><a href="#/xhtml/preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="toca"><a href="#/xhtml/ch01">1. Moral Inevitability and Military Necessity</a></p>
<p class="toca"><a href="#/xhtml/ch02">2. Radical Christians and the Emancipation Proclamation</a></p>
<p class="toca"><span href="#/xhtml/ch03" title="Link target outside of Sample">3. The Election of 1862</span></p>
<p class="toca"><span href="#/xhtml/ch04" title="Link target outside of Sample">4. Rise Up O Man of God!</span></p>
<p class="toca"><span href="#/xhtml/ch05" title="Link target outside of Sample">5. The Election of 1864</span></p>
<p class="toca"><span href="#/xhtml/ch06" title="Link target outside of Sample">6. The Churches and Presidential Reconstruction</span></p>
<p class="toca"><span href="#/xhtml/ch07" title="Link target outside of Sample">7. The Christian Opposition to Johnson</span></p>
<p class="toca"><span href="#/xhtml/ch08" title="Link target outside of Sample">8. The Fourteenth Amendment and the Election of 1866</span></p>
<p class="toca"><span href="#/xhtml/ch09" title="Link target outside of Sample">9. Impeachment and the Churches</span></p>
<p class="toc"><span href="#/xhtml/ch10" title="Link target outside of Sample">10. Black Suffrage as a Moral Duty</span></p>
<p class="toc"><span href="#/xhtml/ch11" title="Link target outside of Sample">11. The Black Suffrage Referenda of 1867</span></p>
<p class="toc"><span href="#/xhtml/ch12" title="Link target outside of Sample">12. The Fifteenth Amendment</span></p>
<p class="toc"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/abbrevations" title="Link target outside of Sample">Abbreviations</span></p>
<p class="toc"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/biblography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3e2f02db